"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIME_TYPE = exports.MEDIA_MIME_TYPE = exports.VIDEOAUDIO_MIME_TYPE = exports.IMAGETRACK_MIME_TYPE = exports.TEXTTRACK_MIME_TYPE = exports.MANIFEST_MIME_TYPE = void 0;
exports.MANIFEST_MIME_TYPE = {
    DASH: 'application/dash+xml',
    MPEG_DASH: 'video/vnd.mpeg.dash.mpd',
    M3U8: 'application/x-mpegurl',
    HLS: 'application/vnd.apple.mpegurl',
    SMOOTH_STREAM_NONXML: 'application/vnd.ms-ss',
    SMOOTH_STREAM: 'application/vnd.ms-sstr+xml',
    OFFLINE_MANIFEST: 'application/x-offline-manifest',
};
exports.TEXTTRACK_MIME_TYPE = {
    WEBVTT: 'text/vtt',
    TTML: 'application/ttml+xml',
    SUBRIP: 'application/x-subrip',
};
exports.IMAGETRACK_MIME_TYPE = {
    JPEG: 'image/jpeg',
    PNG: 'image/png',
};
exports.VIDEOAUDIO_MIME_TYPE = {
    MP3_AUDIO: 'audio/mp3',
    MP4_VIDEO: 'video/mp4',
    MP4_AUDIO: 'audio/mp4',
    WEBM_VIDEO: 'video/webm',
    MPEG_VIDEO: 'video/mp2t',
};
exports.MEDIA_MIME_TYPE = __assign(__assign(__assign({}, exports.VIDEOAUDIO_MIME_TYPE), exports.TEXTTRACK_MIME_TYPE), exports.IMAGETRACK_MIME_TYPE);
exports.MIME_TYPE = __assign(__assign({}, exports.MANIFEST_MIME_TYPE), exports.MEDIA_MIME_TYPE);
//# sourceMappingURL=MimeTypes.js.map